// Mock IAP service for web platform
// In-app purchases are not supported on web

// Types are defined inline to match the mock structure
export type Product = {
	productId: string;
	title?: string;
	description?: string;
	price?: string;
	currency?: string;
	localizedPrice?: string;
};

export type Subscription = Product;

export type Purchase = {
	productId: string;
	transactionId?: string | null;
	transactionReceipt?: string;
	purchaseToken?: string;
	transactionDate?: number;
};

export type PurchaseError = {
	code: string;
	message: string;
	responseCode?: string;
};

export type IAPProductType = 'CHIPS' | 'VIP_MEMBERSHIP';

class IAPService {
	async initialize(): Promise<boolean> {
		console.warn('[IAP] Web platform does not support IAP');
		return false;
	}

	async disconnect(): Promise<void> {
		console.warn('[IAP] Web platform does not support IAP');
	}

	async getAvailableProducts(): Promise<Product[]> {
		console.warn('[IAP] Web platform does not support IAP - getAvailableProducts');
		return [];
	}

	async getAvailableSubscriptions(): Promise<Subscription[]> {
		console.warn('[IAP] Web platform does not support IAP - getAvailableSubscriptions');
		return [];
	}

	async purchaseProduct(): Promise<void> {
		console.warn('[IAP] Web platform does not support IAP - purchaseProduct');
		throw new Error('IAP not supported on web platform');
	}

	async purchaseSubscription(): Promise<void> {
		console.warn('[IAP] Web platform does not support IAP - purchaseSubscription');
		throw new Error('IAP not supported on web platform');
	}

	async finishTransaction(): Promise<void> {
		console.warn('[IAP] Web platform does not support IAP - finishTransaction');
	}

	async acknowledgePurchaseAndroid(): Promise<void> {
		console.warn('[IAP] Web platform does not support IAP - acknowledgePurchaseAndroid');
	}

	async consumePurchaseAndroid(): Promise<void> {
		console.warn('[IAP] Web platform does not support IAP - consumePurchaseAndroid');
	}

	setupPurchaseListeners(): void {
		console.warn('[IAP] Web platform does not support IAP - setupPurchaseListeners');
	}

	removePurchaseListeners(): void {
		console.warn('[IAP] Web platform does not support IAP - removePurchaseListeners');
	}

	mapPackageToProductId(): string | null {
		console.warn('[IAP] Web platform does not support IAP - mapPackageToProductId');
		return null;
	}

	isIAPSupported(): boolean {
		return false;
	}
}

export const iapService = new IAPService();
